import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import HistoryRow from "./HistoryRow";

const AllTransactionsTable = ({ onPostClick, refreshTrigger, formState }) => {
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
  const fetchPosts = async () => {
    try {
      const res = await axios.get("https://miracleapi.com/transaction/getAllTransactions"); 
      console.log('all trans: ', res.data);
      setPosts(res.data || []); 
    } catch (error) {
      console.error("Failed to fetch posts:", error);
    }
  };

  fetchPosts();
}, [refreshTrigger, formState]);

  let filteredPosts = posts;
  if (formState?.sellCurrency && formState?.buyCurrency) {
    filteredPosts = filteredPosts.filter(
      (post) =>
        post.primary_currency === formState.sellCurrency &&
        post.secondary_currency === formState.buyCurrency
    ).slice(0, 10);;
  }
  console.log('history post: ', filteredPosts)

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-header border-0">
            <h4 className="card-title">
              Recent Trade History
            </h4>
          </div>
          <div className="card-body pt-0">
            <div className="transaction-table">
              <div className="table-responsive">
                <table className="table mb-0 table-responsive-sm">
                  {filteredPosts.length > 0 ? (
                    filteredPosts.map((post) => (
                      <HistoryRow
                        key={post.id}
                        primaryCurrency={post.primary_currency}
                        secondaryCurrency={post.secondary_currency}
                        account={
                          post.default_card ||
                          post.default_bank ||
                          "Unknown Source"
                        }
                        amount={post.amount_paid}
                        rate={post.purchase_amount/post.amount_paid}
                        post={post}
                        onClick={(mode) => onPostClick(post, mode)}
                      />
                    ))
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan="6" className="text-center text-muted py-4">
                          {t("no.available.posts.label")}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllTransactionsTable;
